import { isEnabledExportExecutiveList, isEnabledSendLetter } from './planUtils';
import { hasKLFollowCallBeenEnabled, isHasLetterOrders} from './userUtils';
import { isEnableCapSizeFilter, isEnableKLOperatorAdvancedSearch } from './userOptionUtils';

/**
 * フィルターの表示可否を判定
 * @param {string} property フィルターのプロパティ名
 * @param {object} user ユーザー
 * @returns {boolean} フィルターの表示可否
 */
export const isVisibleFilter = (property, user) => {
  let isVisible = true;
  switch (property) {
    case 'unique_per_corporation': // cap_size_per_corporationが有効な場合は非表示(おそらくこのフィルターは使われてないので消してもよい)
      isVisible = !isEnableCapSizeFilter(user);
      break;
    case 'cap_size_per_corporation': // 表示する人数を制限
      isVisible = isEnableCapSizeFilter(user);
      break;
    case 'sent_status':
    case 'corporation_sent_status':
      isVisible = isEnabledSendLetter(user);
      break;
    case 'follow_call_order_status':
      isVisible = isEnabledSendLetter(user) && hasKLFollowCallBeenEnabled(user);
      break;
    case 'attack_list_generator':
      isVisible = isEnableKLOperatorAdvancedSearch(user);
      break;
    case 'download_status':
      isVisible = isEnabledExportExecutiveList(user);
      break;
    case 'corporation_statistics_change':
      isVisible = false;  // CorporationXXXXHistoryデータがある程度溜まって十分な検索結果が出ないため非表示
      break;
    case 'timeline_status':
      isVisible = isHasLetterOrders(user);
      break;
    case 'jsic':
      isVisible = false; // 非表示
      break;
    case 'number_of_stores':
    case 'fundraising':
      isVisible = isEnableKLOperatorAdvancedSearch(user);
      break;
    default:
      isVisible = true;
  }

  return Boolean(isVisible);
}




// WEBPACK FOOTER //
// ./src/utils/executiveListAuthorityUtils.js